<template>
    <div class="inline-flex items-center space-x-2 py-2 -my-px">
        <span
            aria-checked="false"
            class="relative inline-block flex-shrink-0 h-5 w-10 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-300"
            :class="value ? 'bg-blue-500' : 'bg-gray-200'"
            :disabled="disabled"
            role="checkbox"
            tabindex="0"
            @click="onClick"
        >
            <span
                aria-hidden="true"
                class="inline-block h-4 w-4 rounded-full bg-white shadow transform transition ease-in-out duration-300"
                :class="value ? 'translate-x-5' : 'translate-x-0'"
            />
        </span>
        <slot />
    </div>
</template>

<script>
    export default {
        props: {
            disabled: {
                type: Boolean,
                default: false,
            },
            value: {
                type: Boolean,
                required: true,
            },
        },

        methods: {
            onClick() {
                this.$emit('input', !this.value);
            },
        },
    };
</script>
